module.exports = __webpack_public_path__ + "static/img/left-num-row-5.00f4f338.png";